<template>
  <v-stepper
    v-model="e1"
    class="background"
  >
    <template>
      <modalError ref="modalError" />
      <modalAlert ref="modalAlert" />
      <v-stepper-header v-show="steps > 1">
        <template v-for="n in steps">
          <v-stepper-step
            :key="`${n}-step`"
            :complete="e1 > n"
            :step="n"
          >
            <span v-if="votesPerVoter > 1" />
          </v-stepper-step>
          <v-divider
            v-if="n !== steps"
            :key="n"
          />
        </template>
      </v-stepper-header>
      <v-stepper-items>
        <v-progress-linear
          v-show="progressBar"
          slot="progress"
          color="blue"
          indeterminate
        />
        <v-stepper-content
          :step="confirmation"
          class="rmv-padding"
        >
          <v-row no-gutters>
            <v-col
              cols="12"
              sm="12"
            >
              <span v-if="showVoteInfo">
                <br />
                <v-alert
                  type="success"
                >
                  Seu voto foi realizado com sucesso.
                </v-alert>
                <p>Eleição: {{ $store.state.vote.electionName }}</p>
                <p>Título: {{ $store.state.vote.identifier }}</p>
                <p>Nome: {{ $store.state.vote.name }}</p>
                <p>Data: {{ $store.state.vote.votedOn }}</p>
              </span>
            </v-col>
          </v-row>
          <!-- <div
            class="col-1"
            v-if="bHidden"
          >
            <v-btn
              @click="printPage"
              tile
              block
              type="btn"
              class="blue-box white-text"
            >
              Imprimir
            </v-btn>
          </div> -->
        </v-stepper-content>
        <v-stepper-content
          v-for="n in steps"
          :key="`${n}-content`"
          :step="n"
          class="rmv-padding pl-0 pr-0"
        >
          <v-container fluid>
            <v-flex>
              <span>{{
                candidateRolesCurrent ? candidateRolesCurrent.name : ''
              }}</span>
            </v-flex>
            <v-flex class="d-flex flex-column justify-center align-center">
              <div class="candidate_vote d-flex justify-center align-start">
                <v-radio-group v-model="candidateIndex">
                  <div class="d-flex flex-column candidate-group">
                    <v-radio
                      class="d-flex flex-row candidate-list"
                      ref="vradio_y"
                      v-for="(item, i) in candidateCurrentList"
                      :key="i"
                      v-on:change="vRadioChange(i)"
                    >
                      <template v-slot:label>
                        <div
                          ref="divCandidate"
                          class="d-flex flex-row align-items-stretch canditate-item"
                          :key="item.number"
                          @click="listItemEvent(i)"
                        >
                          <div class="d-flex candidate-img">
                            <v-img
                              :width="img.value.width"
                              :height="img.value.height"
                              :src="item.picture ? item.picture : (item.nickname == 'Voto Nulo' ? imgNulo : imgBranco)"
                              aspect-ratio="1.0"
                            />
                          </div>
                          <div
                            class="d-flex flex-column align-items-center justify-center px-2 candidate-info"
                          >
                            <div
                              :class="objClass.value"
                              v-html="
                                item.number == '-1' || item.number == '-2'
                                  ? ''
                                  : item.number
                              "
                            />
                            <div
                              :class="objClass.value"
                              v-html="item.nickname"
                            />
                          </div>
                        </div>
                      </template>
                    </v-radio>
                  </div>
                </v-radio-group>
              </div>

              <div class="urna_teclado mt-8">
                <div
                  class="d-flex flex-row justify-center align-start teclas_acao teclas_acao_mosaic"
                >
                  <v-btn
                    color="error"
                    class="tertiary--text mr-2"
                    @click="clearCandidate"
                  >
                    Corrige
                  </v-btn>
                  <v-btn
                    color="success"
                    class="tertiary--text"
                    @click="nextStep(n)"
                    :disabled="!isAllowedToContinue"
                  >
                    Confirma
                  </v-btn>
                </div>
              </div>
            </v-flex>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </template>
  </v-stepper>
</template>
<script>
import { mapActions } from 'vuex';
import util from '@/utils/util';
import modalError from '@/components/ModalError';
import modalAlert from '@/components/ModalAlert';
var selectedNumber = null;
export default {
  components: {
    modalError,
    modalAlert
  },
  data: () => ({
    e1: '',
    steps: 1,
    votesPerVoter: 0,
    contadorVotos: 0,
    bHidden: true,
    progressBar: false,
    showVoteInfo: false,
    candidateRolesList: null,
    candidateRolesCurrent: null,
    RolesList: null,
    confirmation: 0,
    candidateList: null,
    candidateCurrentList: null,
    candidateCurrent: null,
    candidateIndex: null,
    clientIP: null,
    votes: [],
    isAllowedToContinue: false,
    imgPadrao: require('@/assets/img/Empty.png'),
    imgBranco: require('@/assets/img/VotoBranco.png'),
    imgNulo: require('@/assets/img/VotoNulo.png'),
    imgDefaultCandidate: require('@/assets/img/CandidatoDefault.png'),
    idVoteNull: 'VoteNull',
    statusVote: '',
    TimerEnd: {
      bFlagActivateTimer: false,
      value: null
    },
    TimerUrn: {
      bFlagActivateTimer: false,
      value: null
    },
    timoutUrn: null,
    img: {
      imgClass: undefined,
      value: {
        width: undefined,
        height: undefined
      },
      default: {
        width: 100,
        height: 100
      },
      mobile: {
        width: 55,
        height: 55
      }
    },
    windowEvents: {
      RESIZE: 'resize'
    },
    objClass: {
      value: '',
      default: '',
      caption: 'caption'
    }
  }),
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    statusVote(val) {
      this.getVote();
    },
    showVoteInfo(val) {
      if (val) {
        if (this.TimerEnd.bFlagActivateTimer) {
          setTimeout(() => {
            this.$store.state.logout();
          }, this.TimerEnd.value);
        }
      }
    },
    'TimerUrn.bFlagActivateTimer': function(value) {
      this.createDestroyTimeOut(value);
    }
  },
  beforeDestroy() {
    window.removeEventListener(this.windowEvents.RESIZE, this.checkDevice);
  },
  beforeMount() {
    window.addEventListener(this.windowEvents.RESIZE, this.checkDevice);
    this.checkDevice();
  },
  mounted() {
    if (!this.$store.state.login.accessValid) {
      this.$router.push({ name: 'Login' });
    }
    this.e1 = 1;
    // var list = [];
    this.getElection();

    fetch('https://httpbin.org/ip')
      .then(response => response.json())
      .then(response => {
        this.clientIp = response.origin;
      });
  },
  methods: {
    ...mapActions('vote', { saveVote: 'save', get: 'get' }),
    ...mapActions('election', { getByElectionId: 'get' }),
    ...mapActions('candidate', {
      getListCandidate: 'getListCandidateElection'
    }),

    async getElection() {
      await this.getByElectionId({
        idElection: this.$store.state.login.election
      });
      this.votesPerVoter = this.$store.state.election.votesPerVoter;
      this.candidateRolesList = this.$store.state.election.candidateRolesArray;
      this.RolesList = this.candidateRolesList;
      if (this.candidateRolesList && this.candidateRolesList.length > 0) {
        this.steps = this.candidateRolesList.length * this.votesPerVoter;
        this.confirmation = this.steps + 1;
      } else if (this.votesPerVoter > 0) {
        this.steps = this.votesPerVoter;
        this.confirmation = this.votesPerVoter + 1;
      }
      this.getCandidates(this.selectCurrentRole);
      this.TimerEnd.bFlagActivateTimer = this.$store.state.election.receiptTime;
      this.TimerEnd.value = this.$store.state.election.receiptTimeValue;
      this.TimerUrn.bFlagActivateTimer = this.$store.state.election.votingTime;
      this.TimerUrn.value = this.$store.state.election.votingTimeValue;
    },
    async getVote() {
      await this.get({
        idElection: this.$store.state.login.election
      });
      if (this.$store.state.vote.has_voted) {
        this.statusAlert = 'success';
        this.msgAlert = 'Voto realizado com sucesso !';
        this.showVoteInfo = true;
        this.progressBar = false;
        this.$store.commit('setShowAlertManyVotes', false);
      }
    },
    async getCandidates(callback) {
      var param = {
        idElection: this.$store.state.login.election,
        idSection: this.$store.state.voter.section_id,
        voting: this.$store.state.election.voting
      };
      await this.getListCandidate(param);
      this.candidateList = this.$store.state.candidate.listCandidateElection;
      // Scroll and focus on menu
      // this.$nextTick(() => {
      //   this.$refs.menu.scrollIntoView();
      //   this.$refs.menu.focus();
      // });
      if (callback) {
        callback();
      }
    },
    printPage() {
      this.bHidden = false;
      window.print();
      this.bHidden = true;
    },
    async nextStep(n) {
      this.isAllowedToContinue = false;
      if (!this.validationExistVote()) {
        this.stepCurrent = null;
        this.contadorVotos++;
        if (n === this.steps) {
          // Last step
          this.progressBar = true;
          this.insertVoterArray(false);
          var dataPost = {
            identifier: this.$store.state.login.identifier,
            region: this.$store.state.voter.region_id,
            votes: [],
            has_voted: false,
            electionId: this.$store.state.login.election,
            clientIp: this.clientIp
          };

          for (var i = 0; i < this.votes.length; i++) {
            dataPost.votes.push(this.votes[i]);
          }
          this.votes = [];
          try {
            await this.saveVote({
              vote: dataPost
            }).then(() => {
              if (this.$store.state.vote.status === 'ok') {
                this.e1 = n + 1;
                this.statusVote = 'ok';
              } else if (
                this.$store.state.vote.msgError === 'Vote not committed'
              ) {
                this.saveVote({
                  vote: dataPost
                }).then(() => {
                  if (this.$store.state.vote.status === 'ok') {
                    this.e1 = n + 1;
                    this.statusVote = 'ok';
                  } else {
                    this.$refs.modalError.Load(true, this.$store.state.logout);
                  }
                });
              } else {
                this.statusAlert = 'error';
                this.msgAlert = 'Voto não pode ser realizado !';
                this.$refs.modalError.Load(true, this.$store.state.logout);
              }
            });
          } catch (error) {
            this.$refs.modalError.Load(true, this.$store.state.logout);
          } finally {
            this.loading = false;
          }
        } else {
          this.e1 = n + 1;
          this.insertVoterArray(true);
          this.clearCandidate();
          if (this.RolesList && this.RolesList.length > 0) {
            if (this.contadorVotos === this.votesPerVoter) {
              this.selectCurrentRole();
              this.contadorVotos = 0;
            }
          }
          // Foco no título do formulário

          this.$nextTick(() => {
            // this.$refs.form.scrollIntoView();
          });

          window.scrollTo(0, 0);
        }
      } else {
        this.$refs.modalAlert.Load(
          true,
          'Eleição',
          'Já existe um voto para este candidato.',
          'error'
        );
      }
      this.isAllowedToContinue = true;
    },
    selectCurrentRole() {
      if (this.RolesList && this.RolesList.length > 0) {
        this.candidateRolesCurrent = this.RolesList[0];
        this.RolesList = this.RolesList.filter(
          item => item !== this.candidateRolesCurrent
        );
        this.selectCurrentListCandidate();
      } else {
        this.selectCurrentListCandidate();
      }
    },
    selectCurrentListCandidate() {
      if (this.candidateRolesCurrent != null) {
        this.candidateCurrentList = this.candidateList.filter(
          item => item.candidaterole_id === this.candidateRolesCurrent.id
        );
      } else {
        this.candidateCurrentList = this.candidateList;
      }

      this.candidateCurrentList.forEach(candidato => {
        if (candidato.picture === null) {
          candidato.picture = this.imgDefaultCandidate;
        }
      });

      this.addItemWhite(this.candidateCurrentList);
      this.addItemNull(this.candidateCurrentList);
    },
    addItemNull(listCandidate) {
      var itemNull = {
        id: this.idVoteNull,
        name: 'Voto Nulo',
        nickname: 'Voto Nulo',
        number: '-2',
        picture: null
      };
      listCandidate.push(itemNull);
    },
    addItemWhite(listCandidate) {
      var itemWhite = {
        id: this.idVoteNull,
        name: 'Voto Branco',
        nickname: 'Voto Branco',
        number: '-1',
        picture: null
      };
      listCandidate.push(itemWhite);
    },
    removeCandidateSelected() {
      if (
        this.candidateCurrentList != null &&
        this.candidateCurrentList.length > 0
      ) {
        if (this.votes.length > 0) {
          for (const idxVoto in this.votes) {
            var itemVoto = this.votes[idxVoto];
            if (
              itemVoto.candidateNumber !== '-1' &&
              itemVoto.candidateNumber !== '-2'
            ) {
              this.candidateCurrentList = this.candidateCurrentList.filter(
                item => item.number !== itemVoto.candidateNumber
              );
            }
          }
        }
      }
    },
    selectCandidateInList(callback) {
      if (
        this.candidateCurrentList != null &&
        this.candidateCurrentList.length > 0
      ) {
        if (this.candidateIndex != null) {
          this.candidateCurrent = this.candidateCurrentList[
            this.candidateIndex
          ];
        }
      }
      if (callback) {
        callback();
      }
    },
    listItemEvent(index) {
      this.isAllowedToContinue = false;
      this.candidateIndex = index;
      // this.applyClassCandidateSelected(index);
      this.selectCandidateInList(this.enableContinue);
    },
    enableContinue() {
      if (this.candidateCurrent.number !== selectedNumber) {
        selectedNumber = this.candidateCurrent.number;
        setTimeout(() => {
          if (selectedNumber !== null) {
            this.isAllowedToContinue = true;
          } else {
            this.candidateIndex = null;
            this.candidateCurrent = null;

            this.isAllowedToContinue = false;
          }
        }, 1000);
      } else {
        this.candidateIndex = null;
        this.candidateCurrent = null;

        selectedNumber = null;
        this.isAllowedToContinue = false;
      }
    },
    clearCandidate() {
      this.enableContinue();
    },
    insertVoterArray(bFlagRemoveCandidate) {
      if (this.candidateCurrent) {
        if (this.candidateRolesCurrent) {
          const voteData = {
            roleID: this.candidateRolesCurrent.id,
            candidateNumber: this.candidateCurrent.number
          };
          this.votes.push(voteData);
        } else {
          const voteData = {
            roleID: null,
            candidateNumber: this.candidateCurrent.number
          };
          this.votes.push(voteData);
        }
        if (bFlagRemoveCandidate) {
          this.removeCandidateSelected();
        }
      }
    },
    validationExistVote() {
      let bFlag = false;
      if (!(this.candidateCurrent.number === '-1' || this.candidateCurrent.number === '-2')) {
        if (this.votes.length > 0) {
          const arrayResult = this.votes.filter(
            x => x.candidateNumber === this.candidateCurrent.number
          );
          if (arrayResult && arrayResult.length > 0) {
            bFlag = true;
          }
        }
      }
      return bFlag;
    },
    createDestroyTimeOut(bCreateDestroy) {
      if (bCreateDestroy) {
        var time = this.TimerUrn.value;
        this.timoutUrn = setTimeout(() => {
          this.$store.state.logout();
        }, time);
      } else {
        if (this.timoutUrn) {
          clearInterval(this.timoutUrn);
        }
      }
    },
    vRadioChange(value) {
      if (!this.$refs.vradio_y[value].isActive) {
        this.listItemEvent(value);
      }
    },
    checkDevice() {
      setTimeout(this.changeParametersDesign, 150);
    },
    changeParametersDesign() {
      const result = util.isMobile();
      let width = this.img.default.width;
      let height = this.img.default.height;
      let classFont = this.objClass.default;
      if (result) {
        width = this.img.mobile.width;
        height = this.img.mobile.height;
        classFont = this.objClass.caption;
      }
      this.img.value.width = width;
      this.img.value.height = height;
      this.objClass.value = classFont;
    }
  }
};
</script>
<style>
.v-application--wrap {
  min-height: 100vh !important;
}
</style>
